module.exports = __webpack_public_path__ + "static/img/dragonVRPhone.cf021c65.png";